import { useEffect, useState } from "react";
import { Check, Pencil, Trash2, X, SlidersHorizontal, ChevronDown } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { PriceOptionsEditor } from "./PriceOptionsEditor";

export const CategoryRow = ({ cat, onUpdate, onDelete }) => {
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(cat.name);
  const [extras, setExtras] = useState(cat.extras || []);
  const base = { name: cat.name, active: cat.active, has_extras: !!cat.has_extras, half_and_half: !!cat.half_and_half, has_doughs: !!cat.has_doughs, extras: cat.extras || [], order: cat.order };
  const on = !!cat.has_extras;

  useEffect(() => {
    setExtras(cat.extras || []);
  }, [cat.extras]);

  const toggleExtras = () => {
    onUpdate({ ...base, has_extras: !on, half_and_half: on ? false : base.half_and_half, has_doughs: on ? false : base.has_doughs });
    setOpen(!on);
  };

  return (
    <div className="rounded-xl bg-[#120E0E] border border-[#2E2323]" data-testid={`category-row-${cat.id}`}>
      <div className="flex flex-wrap items-center gap-2 p-3">
        {editing ? (
          <>
            <input value={name} onChange={(e) => setName(e.target.value)} className="field-dark flex-1 min-w-0 rounded-lg px-3 py-1.5 text-sm" data-testid={`category-name-input-${cat.id}`} />
            <button onClick={() => { onUpdate({ ...base, name }); setEditing(false); }} className="p-1.5 text-green-400" data-testid={`category-save-btn-${cat.id}`}><Check className="w-4 h-4" /></button>
            <button onClick={() => { setName(cat.name); setEditing(false); }} className="p-1.5 text-[#A89F91]"><X className="w-4 h-4" /></button>
          </>
        ) : (
          <>
            <span className={`basis-full sm:basis-auto flex-1 min-w-0 break-words text-sm font-semibold ${cat.active ? "" : "text-[#6b6157] line-through"}`}>{cat.name}</span>
            <button onClick={toggleExtras} data-testid={`category-extras-toggle-${cat.id}`} aria-pressed={on}
              className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold border transition-colors ${on ? "bg-green-500/15 text-green-400 border-green-500/40 hover:bg-green-500/25" : "bg-red-500/10 text-red-400 border-red-500/30 hover:bg-red-500/20"}`}>
              <SlidersHorizontal className="w-3 h-3" /> Extras {on ? "ON" : "OFF"}
            </button>
            {on && (
              <button onClick={() => setOpen(!open)} className="p-1 text-[#A89F91]" data-testid={`category-extras-expand-${cat.id}`}>
                <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
              </button>
            )}
            <span className="flex-1 sm:hidden" />
            <button onClick={() => setEditing(true)} className="p-1.5 text-[#A89F91] hover:text-amber-100" data-testid={`category-edit-btn-${cat.id}`}><Pencil className="w-4 h-4" /></button>
            <button onClick={() => onDelete(cat)} className="p-1.5 text-[#A89F91] hover:text-red-400" data-testid={`category-delete-btn-${cat.id}`}><Trash2 className="w-4 h-4" /></button>
            <Switch checked={cat.active} onCheckedChange={(v) => onUpdate({ ...base, active: v })} data-testid={`category-active-switch-${cat.id}`} className="data-[state=checked]:bg-[#DC2626]" />
          </>
        )}
      </div>
      {on && open && (
        <div className="px-3 pb-3 pt-1 space-y-3 border-t border-[#2E2323]" data-testid={`category-extras-panel-${cat.id}`}>
          <PriceOptionsEditor title="Extras de esta categoría (precio adicional)" items={extras} onChange={setExtras} testid={`category-extras-${cat.id}`} />
          <label className="flex items-center gap-2 text-xs text-[#A89F91]">
            <Switch checked={!!cat.half_and_half} onCheckedChange={(v) => onUpdate({ ...base, half_and_half: v })} data-testid={`category-half-switch-${cat.id}`} className="data-[state=checked]:bg-amber-500 scale-90" />
            Permitir mitad y mitad
          </label>
          <label className="flex items-center gap-2 text-xs text-[#A89F91]">
            <Switch checked={!!cat.has_doughs} onCheckedChange={(v) => onUpdate({ ...base, has_doughs: v })} data-testid={`category-dough-switch-${cat.id}`} className="data-[state=checked]:bg-amber-500 scale-90" />
            Mostrar tipo de masa (solo pizzas)
          </label>
          <button onClick={() => onUpdate({ ...base, extras: extras.filter((x) => x.name.trim()) })} data-testid={`category-extras-save-${cat.id}`}
            className="w-full py-2 rounded-full bg-amber-500 text-[#120E0E] text-xs font-bold">Guardar extras</button>
        </div>
      )}
    </div>
  );
};
